/** Un turno: pregunta en burbuja, razonamiento colapsable, respuesta con citas, evidencia y pie.
 *
 * Orden tomado de la referencia del cliente: la pregunta a la derecha en color de acento, el
 * razonamiento agrupado y colapsable, y la evidencia en tarjetas compactas con pestañas —no un
 * muro apilado al final.
 */
import { useState } from "react";
import type { Idioma, Turno } from "../lib/tipos";
import { t } from "../lib/i18n";
import { ProgresoTools } from "./ProgresoTools";
import { RespuestaMarkdown } from "./RespuestaMarkdown";
import { TarjetaEvidencia } from "./TarjetaEvidencia";
import { PieRespuesta } from "./PieRespuesta";
import { TiraFuentes } from "./TiraFuentes";
import { Simbolo } from "./Logo";

export function Mensaje({ turno, idioma, sesionId }: { turno: Turno; idioma: Idioma; sesionId: string | null }) {
  const txt = t(idioma);
  const [resaltada, setResaltada] = useState<string | null>(null);

  const enfocar = (id: string) => {
    setResaltada(id);
    document.getElementById(`tarjeta-${id}`)?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const fuentes = turno.tarjetas.flatMap((x) => x.fuentes);
  const niveles = [...new Set(turno.tarjetas.map((x) => x.nivel))];
  const corte = turno.tarjetas[0]?.corte.texto ?? "";

  return (
    <article className="turno">
      <div className="fila-pregunta">
        <p className="pregunta">{turno.pregunta}</p>
      </div>

      <div className="fila-respuesta">
        <span className="avatar"><Simbolo tamano={17} titulo="TIM" /></span>
        <div className="cuerpo-respuesta">
          <ProgresoTools turno={turno} idioma={idioma} />
          {turno.notas.map((n, i) => <p key={i} className="nota">{n}</p>)}
          {turno.avisos.map((a, i) => <p key={i} className="mal">{a}</p>)}
          {turno.revisando && <p className="nota">{txt.revisando}</p>}

          {turno.tarjetas.length > 0 && (
            <TiraFuentes fuentes={fuentes} niveles={niveles} corte={corte} idioma={idioma} />
          )}

          {turno.respuesta_md && (
            <RespuestaMarkdown md={turno.respuesta_md} idioma={turno.idioma} tarjetas={turno.tarjetas}
                               activa={resaltada} alCitar={enfocar} />
          )}

          {turno.tarjetas.length > 0 && (
            <section className="tarjetas" aria-label={txt.evidencia}>
              {turno.tarjetas.map((tj, i) => (
                <TarjetaEvidencia key={tj.id} tarjeta={tj} idioma={idioma} n={i + 1}
                                  resaltada={resaltada === tj.id} />
              ))}
            </section>
          )}

          <PieRespuesta turno={turno} idioma={idioma} sesionId={sesionId} />
        </div>
      </div>
    </article>
  );
}
